/**
 * Built-in English copy for the registration widget.
 *
 * The theme sends the same strings through the `translations` prop, so the client can edit them in
 * Online Store > Themes > Edit default theme content. These defaults keep the widget correct when
 * it runs standalone (`npm run dev`), or when the theme sends nothing.
 *
 * Keep the shape of this object in step with the `event_registration.tooltips` keys in the theme's
 * locale file. TranslationsContext only reads keys that exist here.
 */
const defaults = {
    tooltips: {
        triggerLabel: "What's this?",

        courseType: {
            title: 'Programme Type',
            bodyHtml: [
                '<p>You can choose to attend this programme either in-person or online.</p>',
                '<hr>',
                '<p><strong>In-Person Programmes</strong></p>',
                '<p>Our programmes are based at University College London (UCL). In addition, our Summer Experiences are also located in industry locations around London to give a realistic experience of working in that career.</p>',
                '<p><strong>Live Online Programmes</strong></p>',
                '<p>Our Live Online programmes take place virtually (UK time zone) and offer a highly interactive experience.</p>',
            ].join(''),
        },

        startDates: {
            // Two forms, because the heading follows the field label, which changes with the number
            // of start dates that loaded.
            title: {
                one: 'Choose Available Start Date',
                other: 'Choose Available Start Dates',
            },
            bodyHtml: [
                '<p>You can choose the start date of your programme. All programmes have highly limited places and operate on a first-come first-served basis. Please note that some programmes only run once.</p>',
            ].join(''),
        },

        duration: {
            title: 'Duration',
            bodyHtml: [
                '<p><strong>For our Weekend Programme</strong></p>',
                '<p>All our weekend programmes are 1 day long and run on a Sunday.</p>',
                '<p><strong>For our Summer Experience</strong></p>',
                '<p>Our summer programmes are the most immersive, one-of-a-kind experiences we offer. You can attend for 1 week or 2 weeks. Choose our 2 week premium option for the ultimate, flagship experience.</p>',
            ].join(''),
        },

        addOns: {
            title: 'Optional Add-Ons',
            bodyHtml: [
                '<p>We offer private accommodation at University of London halls of residence, with meals and 24/7 guardianship included. If you choose accommodation, your check-in will be the day before your programme start date and your check-out will be the day after.</p>',
            ].join(''),
        },
    },
};

export default defaults;
